import axios from 'axios';
import * as _ from 'lodash'

class AddressService {

  getLatLng(cep) {
    return axios.get(`/v2/address/getLatLng/${cep}`).then(r => r.data);
  }

}

// Singleton
const instance = new AddressService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/address.js